import styles from './CheckListPositionsPickerCell.module.scss';

import { Theme, useMediaQuery } from '@mui/material';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import { IPickerProps } from '@work4all/components/lib/components/entity-picker/types';
import { useEntityTemplate } from '@work4all/components/lib/components/entity-template-provider/EntityTemplateProvider';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

interface CheckListPositionsPickerCellProps {
  value: string | number;
  picker: React.ReactElement<IPickerProps<unknown, boolean>>;
  entity: Entities;
  disabled?: boolean;
  onChange?: (value: unknown) => void;
  presetFields?: unknown;
}

export const CheckListPositionsPickerCell = ({
  value,
  picker,
  entity,
  disabled,
  onChange,
  presetFields,
}: CheckListPositionsPickerCellProps) => {
  const { t } = useTranslation();
  const popoverRef = useRef<EntityPickerPopover>(null);
  const entityTemplate = useEntityTemplate();

  const isMobile = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('sm')
  );

  return (
    <EntityPickerPopover
      fullscreen={isMobile}
      ref={popoverRef}
      picker={picker}
      footer={entityTemplate.renderPickerFooter({
        popoverRef,
        entity,
        onChange,
        presetFields,
      })}
      onTargetClick={(e) => {
        e.stopPropagation();
      }}
    >
      <button disabled={disabled} className={styles.button} type="button">
        {value ?? t('COMMON.LINK')}
      </button>
    </EntityPickerPopover>
  );
};
